// Single source of truth for public contact details.
// Import from here instead of hard-coding phone numbers or WhatsApp links.
// Numbers are the verified two-number structure approved for launch.
//
// Do NOT create a WhatsApp link for the office number unless separately
// confirmed that WhatsApp is actively monitored on that line.

export const CONTACT = {
  // Primary consultation & WhatsApp number.
  // Used everywhere the site invites a patient to message on WhatsApp
  // or contact for online consultation / referral communication.
  primary: {
    label: "Online Consultations & WhatsApp",
    display: "+91 96259 30047",
    tel: "tel:+919625930047",
    whatsapp: "https://wa.me/919625930047",
  },
  // Office and appointment-coordination number.
  // Voice only — WhatsApp is not attached to this number.
  office: {
    label: "Office & Appointment Coordination",
    display: "+91 92117 31733",
    tel: "tel:+919211731733",
  },
};
